import { DropdownMenu, type DropdownMenuItem } from '~/components/ui/dropdown';

interface RowActionsMenuProps {
  /** Selector prefix, e.g. `feeds-table-actions-${row.id}`. */
  testId: string;
  /** An action the row cannot take stays in the list as `disabled`; one the person may never take is left out (DESIGN.md §4.6). */
  items: DropdownMenuItem[];
  /** Names the trigger for this row, e.g. `Actions for Welcome message`; default `Open actions menu`. */
  ariaLabel?: string;
}

/** The `⋮` menu in a table's last, `Actions` column (DESIGN.md §4.6). */
export function RowActionsMenu({ testId, items, ariaLabel }: RowActionsMenuProps) {
  return (
    <div className="flex w-full items-center justify-center">
      <DropdownMenu testId={testId} items={items} ariaLabel={ariaLabel} />
    </div>
  );
}
